Object.defineProperty(exports, '__esModule', {
  value: true
});

/**
 * Provides a type-safe way to call Object.keys
 */
var objectKeys = function objectKeys(obj) {
  return Object.keys(obj);
};
exports.objectKeys = objectKeys;